import React from 'react';
import { useEffect } from 'react';
import {useAuthentication } from "meportal/AuthenticationProvider";
import { getSyncStatus} from "../../services/otsEventService";
import AlertBanner from 'meportal/AlertBanner';
import * as Constants from "../../constants/Constants";
  
const SyncStatus: React.FC = React.memo(() => {
    console.log("SyncStatus.tsx")
    const { userData, getLatestAccessToken } = useAuthentication();
    const [isOutOfSync, setIsOutOfSync] = React.useState(false);
    const handleData = (data: any) => {
        if (data) {
            if (data.IsOutOfSync === true) {
               setIsOutOfSync(true); //TODO: Change to true
            } else 
            setIsOutOfSync(false);
        } else {
            setIsOutOfSync(false);
        }
    }

    const getSyncStatusInitial = async () => {
        getLatestAccessToken().then((token) => {
            userData.access_token = token;
            getSyncStatus(userData).then(
                (data) => {
                    handleData(data);
                },
                (error) => {
                    console.log("SyncStatus error on the titlebar", error);
                }
            )
        });
    }
    
    useEffect(() => {
        let isMounted = true;
        const timer = setInterval(() => {
            console.log("SyncStatus timer");
           getSyncStatusInitial();
    }, 60000);
         getSyncStatusInitial();
        // Cleanup function to clear the interval when the component unmounts
        return () => {
            clearInterval(timer);
            isMounted = false;
        }
    }, []);

    return ( 
        <>{ isOutOfSync && (
        <AlertBanner
        alertType="critical"
        title="Data Out of Sync"
        description="The system is Out of Sync. Please notify the MOM."
        appName={Constants.APP_NAME_LEGAL_DISCLAIMER}
    /> )}</>
    );
});

SyncStatus.displayName = 'SyncStatus';

export default SyncStatus;